import { axios } from '@/services/axios';

export const getTRSNode = (nodeId) => {
    const endpoint = `/TRSNode/${nodeId}`;
    const res = axios.get(endpoint);
    return res;
};
